'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M40.4 198.7c.9-2.9 3.4-5 6.4-5.4l153.2-22.6c5.2-.8 9.7-4.1 12.1-8.8L280.7 20.5c1.6-3.4 5.4-5.1 9-4.3s6.2 4.1 6.2 7.8l0 384.7c0 3-1.6 5.7-4.2 7.1L143.4 495c-2.7 1.4-6 1.2-8.4-.6s-3.7-4.8-3.2-7.8L158 331c.9-5.1-.8-10.4-4.5-14L42.4 206.9c-2.2-2.1-2.9-5.3-2-8.2z', 'M212.1 161.8c-2.3 4.8-6.8 8.1-12.1 8.8L46.8 193.3c-3 .4-5.5 2.5-6.4 5.4s-.2 6 2 8.2L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9s18.6 12.2 18.6 23.4l0 384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3l11.3-11.4L153.5 317c3.7 3.7 5.4 8.9 4.5 14L131.8 486.6c-.5 3 .7 6 3.2 7.8s5.8 2 8.4 .6l148.3-79.2c2.6-1.4 4.2-4.1 4.2-7.1l0-384.7c0-3.7-2.6-7-6.2-7.8s-7.4 .9-9 4.3L212.1 161.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;